import React, { useState } from "react";
import Logo from "../imgs/logo.png";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [sidenavOpen, setSidenavOpen] = useState(false);
  const toggleSidenav = () => setSidenavOpen(!sidenavOpen);

  const menuLinks = [
    { href: "#home", label: "Home" },
    { href: "#chi-siamo", label: "Chi Siamo" },
    { href: "#nuova-orchestra", label: "Nuova Orchestra" },
    { href: "#Milarte-Fa-Scuola", label: "Milarte Fa Scuola" },
    { href: "#suona-con-noi", label: "Suona con Noi" },
    { href: "#concerti", label: "Concerti" },
    { href: "#NewGallery", label: "Galleria" },
    { href: "#contatti", label: "Contatti" },
    { href: "#partners", label: "Partners" },
    { href: "#privacy", label: "Privacy" },
    { href: "#5x1000", label: "5x1000" },
  ];

  return (
    <div className="flex flex-col items-center bg-gradient-to-r from-white to-amber-50 shadow-sm z-10">
      {/* LOGO */}
      <div className=" w-3/12 relative flex justify-center items-center">
        <a href="#home">
          <img src={Logo} alt="Logo" className="z-0" />
        </a>
      </div>

      {/* NAVBAR DESKTOP */}
      <nav className="hidden xl:flex items-center bg-white/40 backdrop-blur-md border border-amber-100 rounded-full shadow-sm py-2 px-5 mb-5">
        {menuLinks.map((link, index) => (
          <a
            key={index}
            href={link.href}
            className="relative font-medium text-amber-800 text-sm md:text-base px-3 py-2 mx-1 transition-all duration-300
                       hover:text-amber-600 after:content-[''] after:block after:w-0 after:h-[1px]
                       after:bg-amber-600 after:transition-all after:duration-300 hover:after:w-full"
          >
            {link.label}
          </a>
        ))}
      </nav>

      {/* NAVBAR MOBILE */}
      <div className="xl:hidden flex justify-between items-center w-full px-6 py-3">
        <button
          onClick={toggleSidenav}
          className="text-amber-700 text-3xl focus:outline-none"
        >
          {sidenavOpen ? <FaTimes className="text-white" /> : <FaBars />}
        </button>
      </div>

      {/* MENU MOBILE */}
      <div
        className={`fixed top-0 right-0 h-full w-3/4 sm:w-1/2 bg-gradient-to-b from-amber-200/90 to-amber-100/90 backdrop-blur-xl shadow-2xl transform ${
          sidenavOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-500 ease-in-out z-50`}
      >
        <div className="flex flex-col mt-20 space-y-5 text-center text-amber-800 font-medium">
          {menuLinks.map((link, index) => (
            <a
              key={index}
              href={link.href}
              onClick={() => setSidenavOpen(false)}
              className="text-lg hover:text-amber-600 transition"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
